const Sliders = (function () {
    const imageSliders = document.querySelectorAll('.slider');
    const promoSlider = document.querySelector('.promo__slider');
    const scienceSlider = document.querySelector('.science__slider');

    return {
        initPromoSlider: function () {
            const getSlidersConfiguration = () => {
                return {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    speed: 1000,
                    spaceBetween: 10,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        el: ".promo__pagination",
                        clickable: true,
                    }
                }
            }

            new Swiper(promoSlider, getSlidersConfiguration())
        },

        initScienceSlider: function () {
            const setThumbs = (thumbsBlock, options) => new Swiper(thumbsBlock, options);
            const setMainSlider = (sliderBlock, options) => new Swiper(sliderBlock, options);

            const syncArrows = (mainSlider, thumbsSliderContainer) => {
                const thumbBtnNext = thumbsSliderContainer.querySelector('.science-thumbs__btn--next')
                const thumbBtnPrev = thumbsSliderContainer.querySelector('.science-thumbs__btn--prev')

                thumbBtnNext.addEventListener('click', () => mainSlider.slideNext())
                thumbBtnPrev.addEventListener('click', () => mainSlider.slidePrev())
            }

            const getSlidersConfiguration = () => {
                return {
                    main: {
                        // autoHeight: true,
                        loop: true,
                        spaceBetween: 10,
                        effect: 'fade',
                        // speed: 500,
                        thumbs: {},
                        navigation: {
                            nextEl: `.science-slider__btn--next`,
                            prevEl: `.science-slider__btn--prev`,
                        },
                    },

                    thumbs: {
                        spaceBetween: 10,
                        slidesPerView: 3,
                        slideToClickedSlide: true,
                        breakpoints: {
                            425: {
                                slidesPerView: 4,
                            },

                            640: {
                                slidesPerView: 5,
                            },

                            1024: {
                                slidesPerView: 7,
                            },
                        },
                    }
                }
            }

            let mainSlider, thumbsSlider

            const mainSliderContainer = scienceSlider.querySelector('.science-slider__container');
            const thumbsSliderContainer = scienceSlider.querySelector('.science-thumbs__container');

            const { main: mainSettings, thumbs: thumbsSettings } = getSlidersConfiguration()

            if (!thumbsSliderContainer) {
                setMainSlider(mainSliderContainer, mainSettings)
                return;
            }

            thumbsSlider = setThumbs(thumbsSliderContainer, thumbsSettings);
            mainSettings.thumbs.swiper = thumbsSlider;
            mainSlider = setMainSlider(mainSliderContainer, mainSettings);

            syncArrows(mainSlider, thumbsSliderContainer);
        },

        initImageSlider: function () {
            const setThumbs = (thumbsBlock, options) => new Swiper(thumbsBlock, options);
            const setMainSlider = (sliderBlock, options) => new Swiper(sliderBlock, options);

            const syncArrows = (mainSlider, thumbsSliderContainer) => {
                const thumbBtnNext = thumbsSliderContainer.querySelector('.slider__btn--next')
                const thumbBtnPrev = thumbsSliderContainer.querySelector('.slider__btn--prev')

                thumbBtnNext.addEventListener('click', () => mainSlider.slideNext())
                thumbBtnPrev.addEventListener('click', () => mainSlider.slidePrev())
            }

            const getSlidersConfiguration = () => {
                return {
                    main: {
                        loop: true,
                        spaceBetween: 10,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true
                        },
                        thumbs: {},
                        navigation: {
                            nextEl: `.slider__btn--next`,
                            prevEl: `.slider__btn--prev`,
                        },
                    },

                    thumbs: {
                        loop: true,
                        spaceBetween: 10,
                        slidesPerView: 3,
                        slideToClickedSlide: true,
                        breakpoints: {
                            480: {
                                slidesPerView: 4,
                            }
                        },
                    }
                }
            }

            return slider => {
                let mainSlider, thumbsSlider
                const mainSliderContainer = slider.querySelector('.slider__main .slider__container');
                const thumbsSliderContainer = slider.querySelector('.slider__thumbs .slider__container');
                const { main: mainSettings, thumbs: thumbsSettings } = getSlidersConfiguration()

                if (!thumbsSliderContainer) {
                    setMainSlider(mainSliderContainer, mainSettings)
                    return;
                }

                thumbsSlider = setThumbs(thumbsSliderContainer, thumbsSettings);
                mainSettings.thumbs.swiper = thumbsSlider;
                mainSlider = setMainSlider(mainSliderContainer, mainSettings);

                syncArrows(mainSlider, thumbsSliderContainer);
            }
        },

        init: () => {
            imageSliders && imageSliders.forEach(Sliders.initImageSlider())
            promoSlider && Sliders.initPromoSlider()
            scienceSlider && Sliders.initScienceSlider()
        }
    }
})()

export default Sliders;